import { FunctionComponent, useState } from 'react';

import { TextField, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { unparse } from 'papaparse';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import { blankStudent } from '../constants/inviteStudentsDefaults';
import InviteStudentsContainer from '../InviteStudentsContainer';
import { findDuplicateEmailIndexes, validateStudentInvitations } from '../utils/inviteStudentsValidation';
import parseStudentsCsv from '../utils/parseStudentsCsv';

const StyledTextField = withStyles(() => ({
    root: {
        width: '100%',
        marginBottom: '8px'
    }
}))(TextField);

const StyledItalicsInstructions = withStyles(() => ({
    root: {
        fontStyle: 'italic'
    }
}))(Typography);

const AdvancedInvite: FunctionComponent = () => {
    const { t } = useTranslation('invite_students');
    const { students, setStudents, setErrorIndexes, setDuplicateEmailIndexes, setAlerts, validationErrorAlert } = useContainer(InviteStudentsContainer);

    let initialCsvStudents = unparse(students, { skipEmptyLines: 'greedy', header: false, delimiter: ', ' });
    if (initialCsvStudents === unparse([blankStudent], { skipEmptyLines: 'greedy', header: false, delimiter: ', ' })) {
        initialCsvStudents = '';
    }
    const [csvStudents, setCsvStudents] = useState(initialCsvStudents);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setCsvStudents(event.target.value);
    };

    // set global `students` from csv
    const handleBlur = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const studentsCsvToJson = parseStudentsCsv(event.target.value);
        setStudents(studentsCsvToJson);
        const newErrorIndexes = validateStudentInvitations(studentsCsvToJson);
        setErrorIndexes(newErrorIndexes);
        setDuplicateEmailIndexes(findDuplicateEmailIndexes(studentsCsvToJson));
        if (newErrorIndexes.length > 0) {
            setAlerts((alerts) => [...alerts, validationErrorAlert]);
        }
    };

    return (
        <>
            <Typography>{t('advanced-mode.instructions.part-one')}</Typography>
            <StyledItalicsInstructions>{t('advanced-mode.instructions.part-two')}</StyledItalicsInstructions>
            <StyledTextField
                placeholder={t('advanced-mode.place-holder')}
                variant="outlined"
                multiline
                rows={10}
                onBlur={handleBlur}
                onChange={handleChange}
                value={csvStudents}
            />
        </>
    );
};

export default AdvancedInvite;
